import { render, staticRenderFns } from "./UtilityDetailPublish.vue?vue&type=template&id=50959200&scoped=true&"
import script from "./UtilityDetailPublish.vue?vue&type=script&lang=js&"
export * from "./UtilityDetailPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50959200",
  null
  
)

export default component.exports